<template>
  <img v-if="data" src="static/img/icon-checkmark.png"/>
  <img v-else src="static/img/icon-x.png"/>
</template>

<script>
export default {
  props: ['data']
}
</script>
